import {useSyncStoreWithIsEmbedded} from 'hooks/useSyncStoreWithIsEmbedded'
import {useSyncStoreWithUrl} from 'hooks/useSyncStoreWithUrl'

/**
 * Mirrors React-only runtime values into the store. Mount inside the device
 * layout and capability providers.
 */
export const SyncRuntimeToStore = () => {
  useSyncStoreWithIsEmbedded()
  useSyncStoreWithUrl()

  return null
}
